export default "__VITE_ASSET__cf89a2df__"